// extracted by mini-css-extract-plugin
module.exports = {"modalText":"ExpiredInviteModal_modalText__1y3Xw"};